import * as types from './types';

export const appSetIsReady = isReady => ({
  type: types.APP_SET_IS_READY,
  payload: {
    isReady,
  },
});

export const appSetSessionId = sessionId => ({
  type: types.APP_SET_SESSION_ID,
  payload: {
    sessionId,
  },
});

export const appSetUserId = userId => ({
  type: types.APP_SET_USER_ID,
  payload: {
    userId,
  },
});

export const apiAppRegisterRequest = form => ({
  type: types.APP_REGISTER.REQUEST,
  payload: form,
});


// WEBPACK FOOTER //
// ./src/actions/app/actions.js